// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jUEG","question":"styles_question__19yGu","inputVisibleButton":"styles_inputVisibleButton__Zn6Zb","note":"styles_note__e1Q2y"};